import { useState } from "react";
import universityHeroImage from "../../assets/images/University.png";
import LogoutNavbar from "../../components/LogoutNavbar";
import Footer from "../../components/PostLoginFooter";
import BackButton from "../../components/BackButton"; 
import GlobalSidebar from "../../components/GlobalSidebar";
import { useMediaQuery, useTheme } from "@mui/material";

// ─── Demo Data (replace with real data or API later) ───────────────────────
const COLLEGE_DATA = {
  name: "University of Lucknow",
  tagline: "Gyan Ka Dwar — Gateway of Knowledge",
  established: 1920,
  image: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/University_of_Lucknow_Main_Building.jpg/1280px-University_of_Lucknow_Main_Building.jpg",
  about: `The University of Lucknow, one of India's premier institutions, was established in 1920 under the University of Lucknow Act (No. V of 1920). The idea was first mooted by Raja Sir Mohammad Ali Mohammad Khan of Mahmudabad, and given life by Sir Harcourt Butler, then Lieutenant-Governor of the United Provinces. Teaching began on July 17, 1921, in Faculties of Arts, Science, Commerce, Law, and Medicine.

The University traces its nucleus to three historic colleges — King George's Medical College, Canning College, and Isabella Thoburn College. Generously endowed by the Taluqdars of Oudh, and backed by the Government of Uttar Pradesh, it has grown into a multifaceted institution with world-class research, vibrant campus life, and a legacy spanning over a century.`,
  stats: [
    { label: "Students", value: "20,000+" },
    { label: "Departments", value: "50+" },
    { label: "Years of Legacy", value: "104" },
    { label: "Research Centres", value: "15" },
  ],
  departments: [
    {
      id: 1,
      name: "Computer Science",
      hod: "Prof. Rajeev Srivastava",
      hodEmail: "hod.cs@lkouniv.ac.in",
      hodPhone: "+91-522-2740001",
      faculty: [
        { name: "Dr. Asha Mishra", designation: "Associate Professor", specialization: "Machine Learning", email: "asha.m@lkouniv.ac.in" },
        { name: "Dr. Sandeep Verma", designation: "Assistant Professor", specialization: "Computer Networks", email: "s.verma@lkouniv.ac.in" },
        { name: "Dr. Priya Tiwari", designation: "Assistant Professor", specialization: "Data Science", email: "p.tiwari@lkouniv.ac.in" },
      ],
    },
    {
      id: 2,
      name: "Physics",
      hod: "Prof. K.N. Tripathi",
      hodEmail: "hod.phy@lkouniv.ac.in",
      hodPhone: "+91-522-2740012",
      faculty: [
        { name: "Dr. Meena Agarwal", designation: "Professor", specialization: "Quantum Physics", email: "m.agarwal@lkouniv.ac.in" },
        { name: "Dr. Vivek Pandey", designation: "Associate Professor", specialization: "Optics", email: "v.pandey@lkouniv.ac.in" },
      ],
    },
    {
      id: 3,
      name: "Law",
      hod: "Prof. Sunita Rao",
      hodEmail: "hod.law@lkouniv.ac.in",
      hodPhone: "+91-522-2740025",
      faculty: [
        { name: "Dr. Alok Chaturvedi", designation: "Professor", specialization: "Constitutional Law", email: "a.chaturvedi@lkouniv.ac.in" },
        { name: "Dr. Neha Singh", designation: "Assistant Professor", specialization: "Corporate Law", email: "n.singh@lkouniv.ac.in" },
      ],
    },
    {
      id: 4,
      name: "Commerce",
      hod: "Prof. Ravi Gupta",
      hodEmail: "hod.com@lkouniv.ac.in",
      hodPhone: "+91-522-2740030",
      faculty: [
        { name: "Dr. Suresh Kumar", designation: "Associate Professor", specialization: "Finance", email: "s.kumar@lkouniv.ac.in" },
        { name: "Dr. Anjali Saxena", designation: "Assistant Professor", specialization: "Marketing", email: "a.saxena@lkouniv.ac.in" },
      ],
    },
  ],
  clubs: [
    {
      id: 1,
      name: "E-Cell LU",
      category: "Entrepreneurship",
      tagline: "Build. Launch. Disrupt.",
      color: "#F59E0B",
      icon: "🚀",
      description: "The Entrepreneurship Cell of Lucknow University nurtures innovators and startup founders. We connect students with mentors, investors, and the startup ecosystem.",
      head: { name: "Arjun Kapoor", year: "B.Com 3rd Year", email: "ecell@lkouniv.ac.in", phone: "+91-9876543210" },
      activities: [
        { title: "Startup Weekend 2024", date: "March 15–17", status: "Upcoming" },
        { title: "Pitch Perfect Workshop", date: "Feb 28", status: "Upcoming" },
        { title: "Founders Talk — Series 4", date: "Feb 10", status: "Completed" },
      ],
      members: 120,
    },
    {
      id: 2,
      name: "TPC — Training & Placement",
      category: "Career",
      tagline: "Your Career, Our Mission.",
      color: "#3B82F6",
      icon: "💼",
      description: "The Training & Placement Cell bridges students with top recruiters across industries. We organize mock interviews, résumé workshops, and placement drives.",
      head: { name: "Riya Sharma", year: "MBA 2nd Year", email: "tpc@lkouniv.ac.in", phone: "+91-9988776655" },
      activities: [
        { title: "Campus Placement Drive — Spring", date: "Mar 1–15", status: "Ongoing" },
        { title: "Resume Masterclass", date: "Feb 25", status: "Upcoming" },
        { title: "Mock Interview Sessions", date: "Feb 20", status: "Completed" },
      ],
      members: 200,
    },
    {
      id: 3,
      name: "LUCSE",
      category: "Social Service",
      tagline: "Serve. Inspire. Transform.",
      color: "#10B981",
      icon: "🌱",
      description: "Lucknow University Centre for Social Extension and Research engages students in community development, awareness drives, and social responsibility initiatives.",
      head: { name: "Priya Mishra", year: "MA Sociology 2nd Year", email: "lucser@lkouniv.ac.in", phone: "+91-9123456789" },
      activities: [
        { title: "Plantation Drive 2024", date: "Mar 5", status: "Upcoming" },
        { title: "Blood Donation Camp", date: "Feb 22", status: "Ongoing" },
        { title: "Village Literacy Program", date: "Jan–Ongoing", status: "Ongoing" },
      ],
      members: 350,
    },
    {
      id: 4,
      name: "Rang Manch",
      category: "Cultural",
      tagline: "Drama is Life Amplified.",
      color: "#EC4899",
      icon: "🎭",
      description: "Rang Manch is the drama and theatre club of LU, staging powerful performances, street plays, and workshops on acting, direction, and scriptwriting.",
      head: { name: "Kabir Awasthi", year: "BA Drama 3rd Year", email: "rangmanch@lkouniv.ac.in", phone: "+91-9011223344" },
      activities: [
        { title: "Annual Theatre Festival", date: "April 2–4", status: "Upcoming" },
        { title: "Street Play — Save Water", date: "Mar 12", status: "Upcoming" },
        { title: "Acting Workshop", date: "Feb 18", status: "Completed" },
      ],
      members: 80,
    },
    {
      id: 5,
      name: "Sports Council",
      category: "Sports",
      tagline: "Play Hard. Win Harder.",
      color: "#8B5CF6",
      icon: "⚽",
      description: "The Sports Council coordinates inter-college tournaments, fitness programs, and sports scholarships, representing LU in national and state-level competitions.",
      head: { name: "Varun Singh", year: "BPEd 2nd Year", email: "sports@lkouniv.ac.in", phone: "+91-9812345678" },
      activities: [
        { title: "Inter-University Cricket League", date: "Mar 20", status: "Upcoming" },
        { title: "Annual Sports Meet 2024", date: "Feb 26–28", status: "Ongoing" },
        { title: "Badminton Championship", date: "Feb 10", status: "Completed" },
      ],
      members: 500,
    },
    {
      id: 6,
      name: "Technical Council",
      category: "Technical",
      tagline: "Code. Create. Innovate.",
      color: "#F97316",
      icon: "⚙️",
      description: "The Technical Council fosters innovation through hackathons, coding competitions, robotics workshops, and industry exposure events.",
      head: { name: "Aditya Rastogi", year: "MCA 2nd Year", email: "techcouncil@lkouniv.ac.in", phone: "+91-9654321098" },
      activities: [
        { title: "HackLU 2024 — 36hr Hackathon", date: "April 6–7", status: "Upcoming" },
        { title: "AI/ML Bootcamp", date: "Mar 8–10", status: "Upcoming" },
        { title: "Web Dev Workshop", date: "Feb 14", status: "Completed" },
      ],
      members: 160,
    },
  ],
  contact: {
    address: "University of Lucknow, University Road, Lucknow, Uttar Pradesh — 226007",
    phone: "+91-522-2740404",
    email: "registrar@lkouniv.ac.in",
    website: "www.lkouniv.ac.in",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.6538671441!2d80.93613!3d26.86186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3999564cd2a9f3ef%3A0x1d5ce65e8b14e2b8!2sUniversity%20of%20Lucknow!5e0!3m2!1sen!2sin!4v1708800000000",
  },
};

// ─── Status Badge ────────────────────────────────────────────────────────────
function StatusBadge({ status }) {
  const map = {
    Upcoming: { bg: "#FEF3C7", color: "#92400E", label: "Upcoming" },
    Ongoing: { bg: "#D1FAE5", color: "#065F46", label: "● Ongoing" },
    Completed: { bg: "#F3F4F6", color: "#6B7280", label: "Completed" },
  };
  const s = map[status] || map.Upcoming;
  return (
    <span style={{ background: s.bg, color: s.color, fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 20, letterSpacing: 0.5 }}>
      {s.label}
    </span>
  );
}

// Compact (mobile) Section Header
function ResponsiveSectionHeader({ title, subtitle, compact = false }) {
  return (
    <div style={{ textAlign: "center", marginBottom: compact ? 28 : 48 }}>
      <h2
        style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: compact ? "clamp(22px,6vw,30px)" : "clamp(28px,4vw,40px)",
          color: "#1a1a2e",
          margin: 0,
          letterSpacing: -0.5,
        }}
      >
        {title}
      </h2>
      {subtitle && (
        <p style={{ color: "#6B7280", marginTop: 8, fontSize: compact ? 14 : 16, padding: compact ? "0 8px" : 0 }}>
          {subtitle}
        </p>
      )}
      <div style={{ margin: "14px auto 0", width: compact ? 48 : 60, height: 3, borderRadius: 2, background: "linear-gradient(90deg,#c8a96e,#e8c987)" }} />
    </div>
  );
}

// ─── Faculty Card ─────────────────────────────────────────────────────────────
function FacultyCard({ f, compact = false }) {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        padding: compact ? "14px 14px" : "16px 20px",
        display: "flex",
        gap: compact ? 12 : 14,
        alignItems: "flex-start",
      }}
    >
      <div style={{ width: 42, height: 42, borderRadius: "50%", background: "linear-gradient(135deg,#c8a96e,#e8c987)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>
        👤
      </div>
      <div>
        <div style={{ fontWeight: 700, color: "#1a1a2e", fontSize: 15 }}>{f.name}</div>
        <div style={{ fontSize: 12, color: "#8B5CF6", fontWeight: 600, marginTop: 2 }}>{f.designation}</div>
        <div style={{ fontSize: 12, color: "#6B7280", marginTop: 2 }}>{f.specialization}</div>
        <a href={`mailto:${f.email}`} style={{ fontSize: 12, color: "#c8a96e", textDecoration: "none", marginTop: 4, display: "block" }}>{f.email}</a>
      </div>
    </div>
  );
}

// ─── Department Panel ─────────────────────────────────────────────────────────
function DepartmentPanel({ dept, isOpen, onToggle, compact = false }) {
  return (
    <div style={{ border: "1px solid #e5e7eb", borderRadius: 16, overflow: "hidden", marginBottom: 12, background: "#fff" }}>
      <button
        onClick={onToggle}
        style={{
          width: "100%",
          background: isOpen ? "#1a1a2e" : "#fff",
          border: "none",
          cursor: "pointer",
          padding: compact ? "14px 14px" : "18px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          transition: "background 0.3s",
          gap: 12,
        }}
      >
        <div style={{ textAlign: "left" }}>
          <div style={{ fontWeight: 700, fontSize: compact ? 15 : 17, color: isOpen ? "#e8c987" : "#1a1a2e", fontFamily: "'Playfair Display', serif" }}>
            {dept.name}
          </div>
          <div style={{ fontSize: compact ? 12 : 13, color: isOpen ? "#c8a96e" : "#6B7280", marginTop: 2 }}>
            HOD: {dept.hod} · {dept.faculty.length} Faculty Members
          </div>
        </div>
        <span style={{ fontSize: compact ? 20 : 22, color: isOpen ? "#e8c987" : "#c8a96e", transform: isOpen ? "rotate(45deg)" : "none", transition: "transform 0.3s" }}>+</span>
      </button>

      {isOpen && (
        <div style={{ padding: compact ? "0 14px 16px" : "0 24px 24px", background: "#FAFAF8" }}>
          {/* HOD Info */}
          <div style={{ padding: compact ? "14px 14px" : "16px 20px", background: "linear-gradient(135deg,#1a1a2e,#2d2d4e)", borderRadius: 12, margin: compact ? "14px 0" : "16px 0", display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center" }}>
            <div style={{ fontSize: 32 }}>🎓</div>
            <div>
              <div style={{ fontSize: 11, color: "#c8a96e", fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>Head of Department</div>
              <div style={{ color: "#fff", fontWeight: 700, fontSize: compact ? 15 : 16, marginTop: 2 }}>{dept.hod}</div>
              <div style={{ display: "flex", gap: 16, marginTop: 6, flexWrap: "wrap" }}>
                <a href={`mailto:${dept.hodEmail}`} style={{ color: "#e8c987", fontSize: 12, textDecoration: "none" }}>✉ {dept.hodEmail}</a>
                <a href={`tel:${dept.hodPhone}`} style={{ color: "#e8c987", fontSize: 12, textDecoration: "none" }}>📞 {dept.hodPhone}</a>
              </div>
            </div>
          </div>
          {/* Faculty Grid */}
          <div style={{ display: "grid", gridTemplateColumns: compact ? "1fr" : "repeat(auto-fill,minmax(260px,1fr))", gap: 12 }}>
            {dept.faculty.map((f, i) => <FacultyCard key={i} f={f} compact={compact} />)}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Club Card ────────────────────────────────────────────────────────────────
function ClubCard({ club, isExpanded, onToggle, compact = false }) {
  return (
    <div
      style={{ borderRadius: 20, overflow: "hidden", boxShadow: isExpanded ? "0 20px 50px rgba(0,0,0,0.12)" : "0 4px 16px rgba(0,0,0,0.06)", transition: "box-shadow 0.3s", background: "#fff", border: `1px solid ${club.color}22` }}
    >
      {/* Card Top */}
      <div style={{ background: club.color, padding: compact ? "18px" : "24px", position: "relative" }}>
        <div style={{ position: "absolute", top: -20, right: -20, fontSize: 80, opacity: 0.12 }}>{club.icon}</div>
        <div style={{ fontSize: 36 }}>{club.icon}</div>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700, color: "#fff", marginTop: 8 }}>{club.name}</div>
        <span style={{ fontSize: 11, background: "rgba(255,255,255,0.25)", color: "#fff", padding: "3px 10px", borderRadius: 20, fontWeight: 600 }}>{club.category}</span>
        <div style={{ color: "rgba(255,255,255,0.85)", fontSize: 12, marginTop: 8, fontStyle: "italic" }}>{club.tagline}</div>
        <div style={{ marginTop: 10, fontSize: 12, color: "#fff", opacity: 0.8 }}>👥 {club.members} Members</div>
      </div>

      <div style={{ padding: compact ? 16 : 20 }}>
        <p style={{ color: "#374151", fontSize: 14, lineHeight: 1.6, margin: 0 }}>{club.description}</p>

        <button
          onClick={onToggle}
          style={{ marginTop: 14, background: club.color + "18", color: club.color, border: `1px solid ${club.color}44`, borderRadius: 8, padding: "8px 18px", fontSize: 13, fontWeight: 700, cursor: "pointer", width: "100%" }}
        >
          {isExpanded ? "Hide Details ▲" : "View Details ▼"}
        </button>

        {isExpanded && (
          <div style={{ marginTop: 20, borderTop: "1px solid #f3f4f6", paddingTop: 20 }}>
            {/* Club Head */}
            <div style={{ background: "#FAFAF8", borderRadius: 12, padding: compact ? 14 : 16, marginBottom: 16, border: `1px solid ${club.color}33` }}>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: club.color, textTransform: "uppercase", marginBottom: 8 }}>Club Head</div>
              <div style={{ fontWeight: 700, color: "#1a1a2e" }}>{club.head.name}</div>
              <div style={{ fontSize: 12, color: "#6B7280" }}>{club.head.year}</div>
              <div style={{ marginTop: 8, display: "flex", gap: 12, flexWrap: "wrap" }}>
                <a href={`mailto:${club.head.email}`} style={{ fontSize: 12, color: club.color, textDecoration: "none" }}>✉ {club.head.email}</a>
                <a href={`tel:${club.head.phone}`} style={{ fontSize: 12, color: club.color, textDecoration: "none" }}>📞 {club.head.phone}</a>
              </div>
            </div>

            {/* Activities */}
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: "#6B7280", textTransform: "uppercase", marginBottom: 10 }}>Activities</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {club.activities.map((a, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#F9FAFB", borderRadius: 8, gap: 8 }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 13, color: "#1a1a2e" }}>{a.title}</div>
                    <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 2 }}>📅 {a.date}</div>
                  </div>
                  <StatusBadge status={a.status} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
export default function KnowYourCollege({ data = COLLEGE_DATA, embedded = false } = {}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const compact = isMobile;

  const [activeSection, setActiveSection] = useState("about");
  const [openDept, setOpenDept] = useState(null);
  const [expandedClub, setExpandedClub] = useState(null);
  const [activeClubFilter, setActiveClubFilter] = useState("All");
  const [heroSrc, setHeroSrc] = useState(universityHeroImage);

  const sections = ["about", "faculty", "clubs", "contact"];
  const categories = ["All", ...new Set(data.clubs.map(c => c.category))];
  const filteredClubs = activeClubFilter === "All" ? data.clubs : data.clubs.filter(c => c.category === activeClubFilter);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;1,400&family=DM+Sans:wght@400;500;600&display=swap');
        * { box-sizing: border-box; }
        body { margin: 0; font-family: 'DM Sans', sans-serif; }
        .kyc-nav-btn { transition: all 0.2s; }
        .kyc-nav-btn:hover { background: rgba(200,169,110,0.1) !important; }
        .kyc-nav-btn.active { background: linear-gradient(135deg,#c8a96e,#e8c987) !important; color: #1a1a2e !important; }
        @keyframes fadeIn { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
        .fade-in { animation: fadeIn 0.5s ease forwards; }

        /* Mobile smoothing / ergonomics */
        @media (max-width: 900px) {
          .kyc-nav-btn { padding: 12px 14px !important; font-size: 13px !important; }
          .fade-in { animation-duration: 0.35s; }
        }
      `}</style>

      <div
        style={{
          fontFamily: "'DM Sans', sans-serif",
          background: "#F8F7F2",
          minHeight: embedded ? "auto" : "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {!embedded && <LogoutNavbar />}

        <div style={{ display: "flex", flex: 1 }}>
          {!embedded && !isMobile ? <GlobalSidebar /> : null}

          <div style={{ flex: 1, minWidth: 0 }}>
        {/* ── Hero ── */}
        <div style={{ position: "relative", height: compact ? 360 : "clamp(340px,55vw,520px)", overflow: "hidden", background: "#0b0b14" }}>
          {heroSrc ? (
            <img
              src={heroSrc}
              alt={data.name}
              onError={() => {
                if (heroSrc !== data.image) setHeroSrc(data.image);
                else setHeroSrc("");
              }}
              style={{ width: "100%", height: compact ? "120%" : "140%", objectFit: "cover", filter: "brightness(0.55)" }}
            />
          ) : null}
          <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(26,26,46,0.9) 0%, transparent 60%)" }} />

          {!embedded && (
            <BackButton
              tone="light"
              sx={{ position: "absolute", top: 82, left: { xs: 12, sm: 16 }, zIndex: 2 }}
            />
          )}

          {/* College Name Overlay */}
          <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: compact ? "20px 14px" : "clamp(24px,5vw,60px)", color: "#fff" }}>
            <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 3, color: "#e8c987", textTransform: "uppercase", marginBottom: 8 }}>Est. {data.established}</div>
            <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(28px,5vw,56px)", margin: 0, lineHeight: 1.1, letterSpacing: -1 }}>{data.name}</h1>
            <p style={{ fontSize: "clamp(13px,2vw,17px)", color: "rgba(255,255,255,0.7)", marginTop: 10, fontStyle: "italic" }}>{data.tagline}</p>
          </div>
        </div>

        {/* ── Stats Bar ── */}
        <div style={{ background: "linear-gradient(135deg,#1a1a2e,#2d2d4e)", padding: compact ? "16px 12px" : "20px clamp(16px,5vw,60px)", display: "flex", gap: compact ? 6 : 8, justifyContent: "space-around", flexWrap: "wrap" }}>
          {data.stats.map((s, i) => (
            <div key={i} style={{ textAlign: "center", padding: compact ? "8px 10px" : "8px 20px", minWidth: compact ? "44%" : undefined }}>
              <div style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(22px,4vw,36px)", color: "#e8c987", fontWeight: 700 }}>{s.value}</div>
              <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", letterSpacing: 1, textTransform: "uppercase", marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* ── Sticky Nav ── */}
        <div style={{ position: "sticky", top: embedded ? 0 : 70, zIndex: 10, background: "rgba(248,247,242,0.95)", backdropFilter: "blur(12px)", borderBottom: "1px solid #e5e7eb" }}>
          <div style={{ maxWidth: 1100, margin: "0 auto", padding: compact ? "0 12px" : "0 clamp(16px,4vw,40px)", display: "flex", gap: 4, overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
            {sections.map(s => (
              <button
                key={s}
                className={`kyc-nav-btn${activeSection === s ? " active" : ""}`}
                onClick={() => setActiveSection(s)}
                style={{ padding: "14px 20px", border: "none", background: "transparent", cursor: "pointer", fontSize: 14, fontWeight: 600, color: "#374151", borderBottom: "2px solid transparent", borderRadius: 0, whiteSpace: "nowrap", textTransform: "capitalize" }}
              >
                {s === "faculty" ? "Faculty & Departments" : s === "clubs" ? "Clubs & Activities" : s === "contact" ? "Contact" : "About"}
              </button>
            ))}
          </div>
        </div>

        {/* ── Content ── */}
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: compact ? "28px 12px 44px" : "60px clamp(16px,4vw,40px)" }} className="fade-in" key={activeSection}>

          {/* ── ABOUT ── */}
          {activeSection === "about" && (
            <div>
              <ResponsiveSectionHeader title="About the University" subtitle="A century of excellence, heritage, and learning" compact={compact} />
              <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 32 }}>
                <div style={{ background: "#fff", borderRadius: 20, padding: compact ? "20px" : "40px", boxShadow: "0 4px 24px rgba(0,0,0,0.05)", borderLeft: "4px solid #c8a96e" }}>
                  {data.about.split("\n\n").map((para, i) => (
                    <p key={i} style={{ color: "#374151", lineHeight: 1.8, fontSize: compact ? 14 : 16, margin: i === 0 ? 0 : "16px 0 0" }}>{para}</p>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ── FACULTY ── */}
          {activeSection === "faculty" && (
            <div>
              <ResponsiveSectionHeader title="Faculty & Departments" subtitle="Meet the minds shaping tomorrow's leaders" compact={compact} />
              {data.departments.map(dept => (
                <DepartmentPanel
                  key={dept.id}
                  dept={dept}
                  isOpen={openDept === dept.id}
                  onToggle={() => setOpenDept(openDept === dept.id ? null : dept.id)}
                  compact={compact}
                />
              ))}
            </div>
          )}

          {/* ── CLUBS ── */}
          {activeSection === "clubs" && (
            <div>
              <ResponsiveSectionHeader title="Clubs & Activities" subtitle="Where passion meets community" compact={compact} />

              {/* Filter Pills */}
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center", marginBottom: compact ? 22 : 40 }}>
                {categories.map(cat => (
                  <button
                    key={cat}
                    onClick={() => setActiveClubFilter(cat)}
                    style={{ padding: "8px 20px", border: "1px solid #e5e7eb", borderRadius: 30, fontSize: 13, fontWeight: 600, cursor: "pointer", background: activeClubFilter === cat ? "#1a1a2e" : "#fff", color: activeClubFilter === cat ? "#e8c987" : "#374151", transition: "all 0.2s" }}
                  >
                    {cat}
                  </button>
                ))}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: compact ? "1fr" : "repeat(auto-fill,minmax(300px,1fr))", gap: compact ? 16 : 24 }}>
                {filteredClubs.map(club => (
                  <ClubCard
                    key={club.id}
                    club={club}
                    isExpanded={expandedClub === club.id}
                    onToggle={() => setExpandedClub(expandedClub === club.id ? null : club.id)}
                    compact={compact}
                  />
                ))}
              </div>
            </div>
          )}

          {/* ── CONTACT ── */}
          {activeSection === "contact" && (
            <div>
              <ResponsiveSectionHeader title="Get in Touch" subtitle="We're here to help and connect" compact={compact} />
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px,1fr))", gap: 32 }}>
                <div style={{ background: "#fff", borderRadius: 20, padding: compact ? 18 : 36, boxShadow: "0 4px 24px rgba(0,0,0,0.05)" }}>
                  <h3 style={{ fontFamily: "'Playfair Display', serif", color: "#1a1a2e", marginTop: 0 }}>Contact Information</h3>
                  {[
                    { icon: "📍", label: "Address", val: data.contact.address },
                    { icon: "📞", label: "Phone", val: data.contact.phone, href: `tel:${data.contact.phone}` },
                    { icon: "✉️", label: "Email", val: data.contact.email, href: `mailto:${data.contact.email}` },
                    { icon: "🌐", label: "Website", val: data.contact.website, href: `https://${data.contact.website}` },
                  ].map((item, i) => (
                    <div key={i} style={{ display: "flex", gap: 14, marginBottom: 20, alignItems: "flex-start" }}>
                      <div style={{ width: 40, height: 40, borderRadius: 10, background: "#1a1a2e", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>
                        {item.icon}
                      </div>
                      <div>
                        <div style={{ fontSize: 11, fontWeight: 700, color: "#9CA3AF", letterSpacing: 1, textTransform: "uppercase" }}>{item.label}</div>
                        {item.href
                          ? <a href={item.href} style={{ color: "#c8a96e", fontSize: 14, textDecoration: "none", fontWeight: 500 }}>{item.val}</a>
                          : <div style={{ color: "#374151", fontSize: 14, marginTop: 2 }}>{item.val}</div>
                        }
                      </div>
                    </div>
                  ))}
                </div>

                <div style={{ background: "#1a1a2e", borderRadius: 20, padding: compact ? 18 : 36, color: "#fff" }}>
                  <h3 style={{ fontFamily: "'Playfair Display', serif", color: "#e8c987", marginTop: 0 }}>Reach Out</h3>
                  <p style={{ color: "rgba(255,255,255,0.7)", fontSize: 14, lineHeight: 1.7 }}>
                    Whether you're a student, faculty member, researcher, or visitor — we'd love to hear from you. Reach out through any of our official channels.
                  </p>
                  <div style={{ marginTop: 28 }}>
                    {[
                      { label: "Admissions Enquiry", email: "admissions@lkouniv.ac.in" },
                      { label: "Academic Affairs", email: "academic@lkouniv.ac.in" },
                      { label: "Grievance Cell", email: "grievance@lkouniv.ac.in" },
                    ].map((item, i) => (
                      <div key={i} style={{ padding: "12px 0", borderBottom: i < 2 ? "1px solid rgba(255,255,255,0.1)" : "none" }}>
                        <div style={{ fontSize: 12, color: "#c8a96e", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>{item.label}</div>
                        <a href={`mailto:${item.email}`} style={{ color: "#fff", fontSize: 14, textDecoration: "none" }}>{item.email}</a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

          </div>
        </div>

        {/* ── Footer ── */}
        {!embedded && <Footer/>}
      </div>
    </>
  );
}
